var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2801 8.21983C11.4207 8.07914 11.6113 8.00001 11.8101 7.99983L12.1901 7.99983C12.3886 8.00214 12.5784 8.08095 12.7201 8.21983L17.8501 13.3598C17.9448 13.4537 17.998 13.5815 17.998 13.7148C17.998 13.8482 17.9448 13.976 17.8501 14.0698L17.1401 14.7798C17.048 14.8739 16.9218 14.9269 16.7901 14.9269C16.6585 14.9269 16.5323 14.8739 16.4401 14.7798L12.0001 10.3298L7.56015 14.7798C7.46626 14.8745 7.33847 14.9277 7.20515 14.9277C7.07183 14.9277 6.94403 14.8745 6.85015 14.7798L6.15015 14.0698C6.05549 13.976 6.00225 13.8482 6.00225 13.7148C6.00225 13.5815 6.05549 13.4537 6.15015 13.3598L11.2801 8.21983Z",
    fill: "#C6C6C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownSearch);
export default __webpack_public_path__ + "static/media/arrow_down_search.89b38f64ca13afbb787768e964c2cced.svg";
export { ForwardRef as ReactComponent };